export default __webpack_public_path__ + "static/media/Message.0eea988a.png";